import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore'
import {
  DESIGN_DNA_PHASE1_THOUGHT_DETAILS,
  DESIGN_DNA_PLAN_WORKED_LABEL,
  DESIGN_DNA_THOUGHT_DETAILS,
  DESIGN_DNA_USER_PROMPT,
  buildDesignDnaArtifactPayload,
  buildDesignDnaHtmlArtifactPayload,
  buildDesignDnaPlanBlocks,
  buildDesignDnaShowcaseArtifactPayload,
} from './designDnaDemoContent.js'



export const DESIGN_DNA_DEMO_THREAD_ID = 'thread-demo-design-dna'

export const DESIGN_DNA_DEMO_EXCHANGE_ID = 'exchange-demo-design-dna'

export const DESIGN_DNA_DEMO_USER_MSG_ID = 'msg-demo-design-dna-user'

export const DESIGN_DNA_DEMO_ASSISTANT_MSG_ID = 'msg-demo-design-dna-assistant'

export const DESIGN_DNA_DEMO_ARTIFACT_ID = 'artifact-demo-design-dna-report'

export const DESIGN_DNA_SHOWCASE_ARTIFACT_ID = 'artifact-demo-mui-showcase-worklog'

export const DESIGN_DNA_HTML_ARTIFACT_ID = 'artifact-demo-mui-showcase-html'

export const DESIGN_DNA_DEMO_CONTENT_VERSION = 9

const DEMO_NOW = 1_748_620_000_000

export function ensureDesignDnaDemoArtifactsRegistered() {
  registerArtifactPayload({
    artifactId: DESIGN_DNA_DEMO_ARTIFACT_ID,
    kind: 'doc',
    fileName: 'AI Design DNA — Internal Processing Report.md',
    description: 'Markdown',
    payload: buildDesignDnaArtifactPayload(DESIGN_DNA_DEMO_ARTIFACT_ID),
  })
  registerArtifactPayload({
    artifactId: DESIGN_DNA_SHOWCASE_ARTIFACT_ID,
    kind: 'doc',
    fileName: 'MUI Component Showcase — Worklog.md',
    description: 'Markdown',
    payload: buildDesignDnaShowcaseArtifactPayload(DESIGN_DNA_SHOWCASE_ARTIFACT_ID),
  })
  registerArtifactPayload({
    artifactId: DESIGN_DNA_HTML_ARTIFACT_ID,
    kind: 'html',
    fileName: 'MUI Component Showcase.html',
    description: 'HTML App',
    payload: buildDesignDnaHtmlArtifactPayload(),
  })
}

/** @returns {{ thread: object, messages: object[] }} */
